import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { StripeReader } from '../../../../../../../../../models/location';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../../../utils';
import { AccountService } from '../../../../../../../../../services/account/account.service';
import { LocationService } from '../../../../../../../../../services/location/location.service';


@Component({
  selector: 'app-edit-stripe-reader-modal',
  templateUrl: './edit-stripe-reader-modal.component.html',
  styleUrls: ['./edit-stripe-reader-modal.component.css']
})
export class EditStripeReaderModalComponent implements OnInit {

  @Input() reader: StripeReader;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public loadingSubmit = false;
  public errorMessage = '';

  public serverError: number = null;

  constructor(
    public accountService: AccountService,
    public activeModal: NgbActiveModal,
    public gymService: LocationService
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().is_organization_admin) {
      return;
    }
  }

  public handleSave() {
    this.loadingSubmit = true;

    this.errorMessage = '';

    this.gymService
      .updateTerminal(this.reader)
      .then(updatedReader => {
        this.savedCallback({
          text: updatedReader.label + ' updated successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to edit this payment terminal.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

}
